import ptBR from './pt-BR'
import en from './en'

export default {
  'pt-BR': ptBR,
  en: en,
}
